function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Group_4698",
  "data-name": "Group 4698",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24.636",
  height: "20"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_1961",
  "data-name": "Rectangle 1961",
  fill: "#fff",
  d: "M0 0h24.636v20H0z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Path_2515",
  "data-name": "Path 2515",
  d: "M18.654 11.469h-6.018V14.8h6.018v1.785l5.981-3.449-5.981-3.453z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_1956",
  "data-name": "Rectangle 1956",
  transform: "translate(3.494 10)",
  fill: "#fff",
  d: "M0 0h7.038v1.314H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_1957",
  "data-name": "Rectangle 1957",
  transform: "translate(3.494 7.371)",
  fill: "#fff",
  d: "M0 0h7.832v1.314H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_1958",
  "data-name": "Rectangle 1958",
  transform: "translate(3.494 12.629)",
  fill: "#fff",
  d: "M0 0h7.038v1.314H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_1959",
  "data-name": "Rectangle 1959",
  transform: "translate(3.494 15.257)",
  fill: "#fff",
  d: "M0 0h8.65v1.314H0z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_4699",
  "data-name": "Group 4699"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4698-2",
  "data-name": "Group 4698",
  clipPath: "url(#clip-path)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2516",
  "data-name": "Path 2516",
  d: "M16 18H2V2h10v4h4v4.469h2V5l-5-5H1a1 1 0 00-1 .992v18.016A1 1 0 00.993 20h16.014A1 1 0 0018 18.993V15.8h-2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_1960",
  "data-name": "Rectangle 1960",
  transform: "translate(3.494 4.743)",
  d: "M0 0h4.011v1.314H0z"
})))));